<template>
  <coverage-page
    :customPageControl="pageControl"
    :customDefaultForm="defaultForm"
    :customNeedValidate="needValidate"
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "LongTermCareBenefit",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "長期看護",
        pageBlock: ["period", "formula", "maxCustom"],
        showUpper: true,
      },
      defaultForm: {
        unit_lower: 2,
      },
      needValidate: {
        period_upper: false,
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
